import {
  TextField as AriaTextField,
  type TextFieldProps as AriaTextFieldProps,
  FieldError,
  Input,
  Label,
  Text,
} from 'react-aria-components';
import { composeTwRenderProps, focusRing } from '../utils';

export interface TextFieldProps extends AriaTextFieldProps {
  label: string;
  /** Help text shown under the field. */
  description?: string;
  /** Error message; when set, the field is marked invalid. */
  errorMessage?: string;
  placeholder?: string;
  /** The id of a `<datalist>` offering suggestions. */
  list?: string;
}

/** Labelled text input with description and error slots (React Aria wires up the ARIA attributes). */
export function TextField({
  label,
  description,
  errorMessage,
  placeholder,
  list,
  className,
  ...props
}: TextFieldProps) {
  return (
    <AriaTextField
      {...props}
      isInvalid={props.isInvalid ?? Boolean(errorMessage)}
      className={composeTwRenderProps(className, 'flex flex-col gap-1')}
    >
      <Label className="text-sm font-medium text-fg">{label}</Label>
      <Input
        placeholder={placeholder}
        list={list}
        className={`min-h-touch rounded-md border border-border-strong bg-surface px-3 text-base text-fg placeholder:text-fg-subtle data-[invalid]:border-danger data-[disabled]:opacity-50 ${focusRing}`}
      />
      {description ? (
        <Text slot="description" className="text-sm text-fg-muted">
          {description}
        </Text>
      ) : null}
      <FieldError className="text-sm text-danger-fg">{errorMessage}</FieldError>
    </AriaTextField>
  );
}
